/* External dependencies */
import update from 'react-addons-update';

/* Local dependencies */
import { CreatePasswordActions, CreatePasswordActionsType } from './actions';

export interface CreatePasswordState {
  password: string;
  error: null | string;
  showPassword: boolean;
  validationStatus: {
    hasLowercase: boolean;
    hasUppercase: boolean;
    hasDigit: boolean;
    hasSpecialChar: boolean;
    hasMinLength: boolean;
    isValid: boolean;
  };
}

const initialState: CreatePasswordState = {
  password: '',
  error: null,
  showPassword: false,
  validationStatus: {
    hasLowercase: false,
    hasUppercase: false,
    hasDigit: false,
    hasSpecialChar: false,
    hasMinLength: false,
    isValid: false,
  },
};

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+[{\]};:'",/?]).{8,}$/;

export function createPasswordReducer(state: CreatePasswordState = initialState, action: CreatePasswordActions) {
  switch (action.type) {
    case CreatePasswordActionsType.CREATE_PASSWORD_INPUT:
      let password = action.payload;
      return update(state, {
        password: { $set: password },
        error: { $set: null },
        validationStatus: {
          $set: {
            hasLowercase: /[a-z]/.test(password),
            hasUppercase: /[A-Z]/.test(password),
            hasDigit: /\d/.test(password),
            hasSpecialChar: /[!@#$%^&*()\-_=+[{\]};:'",/?]/.test(password),
            hasMinLength: password.length >= 8,
            isValid: passwordRegex.test(password),
          },
        },
      });

    case CreatePasswordActionsType.SHOW_PASSWORD:
      return update(state, {
        showPassword: { $set: !state.showPassword },
      });

    case CreatePasswordActionsType.CREATE_PASSWORD_SUBMIT:
      if (action.isValid === false) {
        return update(state, {
          error: { $set: action.errorMessage },
        });
      } else if (action.isValid) {
        return update(state, {
          error: { $set: null },
        });
      }

    case CreatePasswordActionsType.RESET_STATE:
      return { ...initialState };

    default:
      return state;
  }
}
